<div class="container-fluid h-100 d-flex flex-column">
  <div class="row align-items-center py-3">
    <div class="col">
      <h2>Vendors</h2>
    </div>
    @if (
      acceptedActionRoles.has(
        $safeNavigationMigration(loggedInUser.UserAccountRole?.role)!
      )
    ) {
      <div class="col-3">
        <button class="btn btn-primary" (click)="assignVendors()">
          Assign Vendors
        </button>
      </div>
    }
  </div>
  <div class="row flex-grow-1">
    <div class="col">
      @if (suppliedGridQueryData) {
        <app-site-vendors-grid
          [suppliedQueryData]="suppliedGridQueryData"
          [ColumnIdToColumnActions]="ColumnIdToColumnActions"
          [gridName]="'ClientSiteVendors'"
          [(reloadGridData)]="reloadGridData"
          (actionEvent)="onActionEvent($event)"
        ></app-site-vendors-grid>
      }
    </div>
  </div>
</div>
